import gsap from "gsap";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

const MenuContext = ({ position, items, onClose }) => {
    const contextRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = () => onClose();
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [onClose]);
    useEffect(() => {
        gsap.to(contextRef.current, {
            height: 20 + items.length * 34 + items.length * 5,
            duration: .25
        });
    }, []);

    if (!position) return null;

    return (
        <div className="contextMenu" ref={contextRef} style={{ 
            position: "absolute", 
            height: 0,
            top: position.y, 
            left: position.x 
        }}>
            <ul>
                {items.map((item, index) =>
                    <div key={item+index}>
                        <li 
                            onClick={() => {
                                item.onClick();
                                onClose();
                            }} 
                            key={item.name+"menuContext"}
                        >
                            {item.icon}{item.name}
                        </li>
                        {index != items.length-1 && <div className="line"></div>}
                    </div>
                )}
            </ul>
        </div>
    )
}

export default observer(MenuContext);